import { Controller } from "@hotwired/stimulus"
import { get, post } from "@rails/request.js"

export default class extends Controller {
  static targets = [
    "shareReading",
    "saveButton",
    "saveDefault",
    "saveConfirmed",
    "mustSaveModal",
    "limitModal"
  ]

  static values = {
    shareUrl: String,
    saveUrl: String,
    upgradeUrl: String,
    savedCount: Number,
    readingSaved: Boolean,
    subscribed: Boolean
  }

  connect() {
    console.log('conenct')
    this.maxFreeSaves = 3
    this.updateUI()
  }

  async save() {
console.log('in save')
console.log('this.savedCountValue: ', this.savedCountValue)
console.log('this.maxFreeSaves: ', this.maxFreeSaves)
console.log('this.subscribedValue: ', this.subscribedValue)
console.log('this.readingSavedValue: ', this.readingSavedValue)
    if (this.savedCountValue >= this.maxFreeSaves && !this.subscribedValue) {
      this.openUpgradeModal()
      return
    }

    const response = await post(this.saveUrlValue, {
      responseKind: "json"
    })

    if (response.ok) {
      this.savedCountValue++
      this.readingSavedValue = true
      this.updateUI()
    }
  }

  share() {
    console.log('share')
    if (!this.readingSavedValue) {
      this.openMustSaveModal()
      return
    }

    this.openShareModal()
  }

  updateUI() {
    this.shareReadingTarget.disabled = !this.readingSavedValue

    if (this.readingSavedValue) {
      this.saveDefaultTarget.classList.add("hidden")
      this.saveConfirmedTarget.classList.remove("hidden")
    } else {
      this.saveDefaultTarget.classList.remove("hidden")
      this.saveConfirmedTarget.classList.add("hidden")
    }
  }

  openMustSaveModal() {
    this.mustSaveModalTarget.classList.remove("hidden")
  }

  openLimitModal() {
    this.limitModalTarget.classList.remove("hidden")
  }

  openUpgradeModal() {
    Turbo.visit(this.upgradeUrlValue, {
      frame: "modal"
    })
  }

  openShareModal() {
    get(this.shareUrlValue, {
      responseKind: "turbo-stream",
      turboFrame: 'modal'
    })
  }
}
